import React from "react";
import MDBox from "materialDashboard/components/MDBox";
import MDBadge from "materialDashboard/components/MDBadge";


const BadgeStatus = ({ status }) => {
    let color;
    switch (status) {
        case "COMPLETED":
            color = "success";
            break;
        case "FAILED":
            color = "error";
            break;
        case "WARNING":
            color = "warning";
            break;
        case "PENDING":
            color = "info";
            break;
        case "IN_PROGRESS":
            color = "info";
            break;
        default:
            color = "dark";
    }
    return <MDBox ml={-1}>
        <MDBadge badgeContent={status} color={color} variant="gradient" size="sm" />
    </MDBox>
}

export default BadgeStatus;